import {
  operatorDeleteMutation,
  operatorRecordQuery,
  operatorRecordsQuery,
} from '@/features/metadata-library/services/operatorQueries';
import {
  venueDeleteMutation,
  venueRecordQuery,
  venueRecordsQuery,
} from '@/features/metadata-library/services/venueQueries';
import type {
  CollectionSlug,
  LibraryRecord,
  LibraryRecordsPage,
} from '@/features/metadata-library/types/metadataLibrary';
import type {
  InfiniteData,
  QueryKey,
  UseInfiniteQueryOptions,
  UseQueryOptions,
} from '@tanstack/react-query';

export const LIBRARY_RECORD_QUERIES: Record<
  CollectionSlug,
  (recordId: string) => UseQueryOptions<LibraryRecord>
> = {
  environments: venueRecordQuery,
  operators: operatorRecordQuery,
};

export const LIBRARY_LIST_QUERIES: Record<
  CollectionSlug,
  (
    q?: string,
    organizationIds?: readonly string[],
  ) => UseInfiniteQueryOptions<
    LibraryRecordsPage,
    Error,
    InfiniteData<LibraryRecordsPage>,
    QueryKey,
    string | undefined
  >
> = {
  environments: venueRecordsQuery,
  operators: operatorRecordsQuery,
};

export const LIBRARY_DELETE_MUTATIONS = {
  environments: venueDeleteMutation,
  operators: operatorDeleteMutation,
};
